var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["hidden", "memberId", "edit", "block", "isVisible"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("hidden", Object.prototype.hasOwnProperty.call(kwargs, "hidden") ? kwargs["hidden"] : true);frame.set("memberId", Object.prototype.hasOwnProperty.call(kwargs, "memberId") ? kwargs["memberId"] : 0);frame.set("edit", Object.prototype.hasOwnProperty.call(kwargs, "edit") ? kwargs["edit"] : true);frame.set("block", Object.prototype.hasOwnProperty.call(kwargs, "block") ? kwargs["block"] : "inner");frame.set("isVisible", Object.prototype.hasOwnProperty.call(kwargs, "isVisible") ? kwargs["isVisible"] : true);var t_5 = "";t_5 += "\n    <div class=\"MemberProfileButtonsEdit MemberProfileButtonsEdit--";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "block"), env.opts.autoescape);
t_5 += "\" data-block=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "block"), env.opts.autoescape);
t_5 += "\" data-memberid=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "memberId"), env.opts.autoescape);
t_5 += "\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "hidden")) {
t_5 += "\n            <div class=\"MemberProfileButtonsEdit-item MemberProfileButtonsEdit-itemEye";
if(!runtime.contextOrFrameLookup(context, frame, "isVisible")) {
t_5 += " hidden";
;
}
t_5 += "\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                     preserveAspectRatio=\"xMidYMid\" width=\"80\" height=\"80\" viewBox=\"-2 -2 84 84\">\n                    <circle cx=\"40\" cy=\"40\" r=\"40\" stroke=\"#000\" stroke-width=\"2\" fill=\"none\"/>\n                    <path d=\"M40.000,53.000 C30.327,53.000 21.967,47.696 17.997,40.000 C21.967,32.304 30.327,27.000 40.000,27.000 C49.673,27.000 58.033,32.304 62.003,40.000 C58.033,47.696 49.673,53.000 40.000,53.000 ZM40.000,32.000 C35.578,32.000 31.992,35.582 31.992,40.000 C31.992,44.418 35.578,48.000 40.000,48.000 C44.422,48.000 48.008,44.418 48.008,40.000 C48.008,35.582 44.422,32.000 40.000,32.000 ZM40.000,43.025 C38.334,43.025 36.983,41.671 36.983,40.000 C36.983,38.329 38.334,36.974 40.000,36.974 C41.666,36.974 43.017,38.329 43.017,40.000 C43.017,41.671 41.666,43.025 40.000,43.025 Z\"\n                          fill=\"#000\" fill-rule=\"evenodd\"/>\n                </svg>\n            </div>\n        ";
;
}
t_5 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "edit")) {
t_5 += "\n            <div class=\"MemberProfileButtonsEdit-item MemberProfileButtonsEdit-itemEdit\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                     preserveAspectRatio=\"xMidYMid\" width=\"80\" height=\"80\" viewBox=\"-2 -2 84 84\">\n                    <circle cx=\"40\" cy=\"40\" r=\"40\" stroke=\"#000\" stroke-width=\"2\" fill=\"none\"/>\n                    <path d=\"M40.923,50.543 L36.679,50.554 L31.355,47.567 L29.012,43.729 L40.892,23.003 L40.871,24.280 L42.709,27.181 L48.249,30.352 L52.265,30.335 L53.000,29.936 L40.923,50.543 ZM46.566,27.118 C45.519,26.516 44.926,25.584 45.242,25.037 C45.559,24.492 46.664,24.538 47.711,25.140 C48.758,25.743 49.351,26.675 49.035,27.221 C48.718,27.767 47.613,27.721 46.566,27.118 ZM29.331,56.994 L29.002,51.470 C30.721,53.878 33.927,54.174 33.927,54.174 L29.331,56.994 Z\"\n                          fill=\"#1a1a1a\" fill-rule=\"evenodd\"/>\n                </svg>\n            </div>\n        ";
;
}
t_5 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileButtonsEdit");
context.setVariable("MemberProfileButtonsEdit", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja
// module id = 15
// module chunks = 0